import AbstractBandsCalculator from "./abstract-bands-calculator";

export default class NationalInsuranceCalculator extends AbstractBandsCalculator {
    constructor(employee, salary, bands) {
        super(salary, bands);
        this.employee = employee;
    }

    calculate() {
        return this.calculateBand('basic') + this.calculateBand('higher');
    }

    getDeductableIncome() {
        return this.salary.getGross('year');
    }

    calculateBand(band)
    {
        if (this.employee.isPensioner) {
            return 0;
        }

        return super.calculateBand(band);
    }
}